export default __webpack_public_path__ + "static/media/ceEUAIActIcon.png";